import React from 'react';
import s from './chat-list-skeleton.module.scss';

const SkeletonItem = () => (
  <div className={s.item}>
    <div className={s.avatar} />
    <div className={s.content}>
      <div className={s.line} />
      <div className={s.shortLine} />
    </div>
  </div>
);

export const ChatListSkeleton = () => {
  return (
    <div className={s.list}>
      {Array.from({ length: 6 }).map((_, i) => (
        <SkeletonItem key={i} />
      ))}
    </div>
  );
};
